import "./App.css";
import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Settings from "./pages/Settings.jsx"
import { CssBaseline, Box, GlobalStyles } from '@mui/material'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ThemeModeContext, darkTheme, lightTheme } from './shared/Theme.jsx';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';


import AuthRoute from "./elements/AuthRoute";
import Login from "./pages/Login.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import CyberRisk from "./pages/CyberRisk.jsx";
import CyberTraining from "./pages/CyberTraining.jsx";
import PhishingSim from "./pages/PhishingSim.jsx";
import Policies from "./pages/Policies.jsx";
import ReportGenerator from "./pages/ReportGenerator.jsx";
import Admin from "./pages/Admin";
import PasswordReset from "./pages/PasswordReset";
import Invite from "./pages/Invite";
import Forgot from "./pages/Forgot";
import DarkWebMonitoring from "./pages/DarkWebMonitoring";
import { LocalizationProvider } from "@mui/x-date-pickers";
import CyberInsurance from "./pages/CyberInsurance";
import EmployeePolicy from "./pages/EmployeePolicy";
import Rags from "./pages/Rags";
import AlertModal from "./elements/Admin/AlertModal";
import PolicyAudit from "./pages/PolicyAudit";
import PenTesting from "./pages/PenTesting";

const App = () => {
	let mode = localStorage.getItem("cymplify_theme_mode");
	if (!mode) {
		mode = "light";
		localStorage.setItem("cymplify_theme_mode", mode);
	}
	const [themeMode, setThemeMode] = useState(mode);
	const theme = createTheme((themeMode === "light")? lightTheme : darkTheme);
	const backgroundColour = (themeMode === "light")? "#eee" : "#2b2a2a";
	
	const appBackgroundStyle = {
		bgcolor: "background.default",
		position: "absolute",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: -10
	};
	
	return (
		<ThemeModeContext.Provider value={{themeMode, setThemeMode}}>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<CssBaseline/>
				<GlobalStyles styles={{ body: { backgroundColor: backgroundColour }}}/>
				<ThemeProvider theme={theme}>
					<Box sx={appBackgroundStyle}></Box>
					<Routes>
						<Route exact path="/login" element={<Login/>}/>
						<Route exact path="/invite/:token" element={<Invite/>}/>
						<Route exact path="/forgot" element={<Forgot/>}/>
						<Route exact path="/employeepolicy/:token" element={<EmployeePolicy/>}/>
						<Route exact path="/password/:token" element={<PasswordReset/>}/>
						<Route exact path="/policyaudit/:token" element={<PolicyAudit/>}/>
						<Route exact path='/' element={<AuthRoute><Dashboard/></AuthRoute>}/>
						<Route exact path='/risk' element={<AuthRoute><CyberRisk/></AuthRoute>}/>
						<Route exact path='/rags' element={<AuthRoute><Rags/></AuthRoute>}/>
						<Route exact path='/training' element={<AuthRoute><CyberTraining/></AuthRoute>}/>
						<Route exact path='/darkweb' element={<AuthRoute><DarkWebMonitoring/></AuthRoute>}/>
						<Route exact path='/pentest' element={<AuthRoute><PenTesting/></AuthRoute>}/>
						<Route exact path='/phishing' element={<AuthRoute><PhishingSim/></AuthRoute>}/>
						<Route exact path='/policies' element={<AuthRoute><Policies/></AuthRoute>}/>
						<Route exact path='/insurance' element={<AuthRoute><CyberInsurance/></AuthRoute>}/>
						<Route exact path='/report' element={<AuthRoute><ReportGenerator/></AuthRoute>}/>
						<Route exact path='/settings' element={<AuthRoute><Settings/></AuthRoute>}/>
						<Route exact path='/admin' element={<AuthRoute><Admin/></AuthRoute>}/>
					</Routes>
					<AlertModal/>
					<div style={{
						position: "fixed",
						right: "0.5em",
						bottom: "0.5em",
						color: "#666",
						fontWeight: "bold",
						fontSize: "x-small"
					}}>
						Cymplify v1.1.3
					</div>
				</ThemeProvider>
			</LocalizationProvider>
		</ThemeModeContext.Provider>
	);
}

export default App;
